"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publish = exports.run = exports.restore = exports.validate = void 0;
const debugModule = require("debug");
const errors = require("../../errors");
const errors_1 = require("../../errors");
const path = require("path");
const subprocess = require("./subprocess");
const fs = require("fs");
const os = require("os");
const debug = debugModule('snyk');
async function handle(operation, command, args) {
    debug(`running dotnet command: ${operation}: ${command}`);
    try {
        return await subprocess.execute(command, args);
    }
    catch (error) {
        if (!(typeof error === 'object' &&
            error !== null &&
            'stdout' in error &&
            'stderr' in error)) {
            throw new errors_1.CliCommandError(`dotnet ${operation} failed with error: ${error}`);
        }
        const message = error.stdout || error.stderr;
        throw new errors_1.CliCommandError(`dotnet ${operation} failed with error: ${message}`);
    }
}
async function validate() {
    const command = 'dotnet';
    const args = ['--version'];
    try {
        await handle('version', command, args);
    }
    catch (error) {
        debug('dotnet tool not found, did you install dotnet core?');
        throw error;
    }
}
exports.validate = validate;
async function restore(projectPath) {
    const command = 'dotnet';
    const args = [
        'restore',
        // Get a larger amount of debugging information to stdout in case something fails.
        // Useful for customers to attempt self-debugging before raising support requests.
        '--verbosity',
        'normal',
        projectPath,
    ];
    const result = await handle('restore', command, args);
    // A customer can define a <BaseOutPutPath> that redirects where `dotnet` saves the assets file. This will
    // get picked up by the dotnet tool and reported in the output logs.
    const regex = /Path:\s+(\S+project.assets.json)/g;
    const matches = result.stdout.matchAll(regex);
    const manifestFiles = [];
    for (const match of matches) {
        manifestFiles.push(match[1]);
    }
    if (manifestFiles.length === 0) {
        throw new errors.FileNotProcessableError('found no information in stdout about the whereabouts of the assets file');
    }
    // Return the last element in the log, as it might be mentioning local asset files in reverse order.
    return manifestFiles[manifestFiles.length - 1];
}
exports.restore = restore;
async function run(projectPath, options) {
    const command = 'dotnet';
    const args = ['run', '--project', projectPath].concat(options);
    const response = await handle('run', command, args);
    return response.stdout;
}
exports.run = run;
async function publish(projectPath, targetFramework) {
    const command = 'dotnet';
    const args = ['publish', '--nologo'];
    // Self-contained: Create all required .dlls for version investigation, don't rely on the environment.
    args.push('--sc');
    // Use the current runtime of whatever platform we are on.
    // This ensures that .dlls will be packaged containing the runtime assembly versions.
    // TODO: (OSM-521) if/when we allow this to be dynamic based on user input, remember to change this.
    args.push('--use-current-runtime');
    // If your .csproj file contains multiple <TargetFramework> references, you need to supply which one you want to publish.
    if (targetFramework) {
        args.push('--framework');
        args.push(targetFramework);
    }
    // Define a temporary output dir to use for detecting .dlls to use for runtime version assembly detection.
    const tempDir = fs.mkdtempSync(path.join(os.tmpdir(), `snyk-nuget-plugin-publish-csharp-`));
    // See https://learn.microsoft.com/en-us/dotnet/core/compatibility/sdk/7.0/solution-level-output-no-longer-valid#recommended-action
    // about why we're not using `--output` for this.
    args.push(`--property:PublishDir=${tempDir}`);
    // The path that contains either some form of project file, or a .sln one.
    // See: https://learn.microsoft.com/en-us/dotnet/core/tools/dotnet-publish#arguments
    args.push(projectPath);
    await handle('publish', command, args);
    return tempDir;
}
exports.publish = publish;
//# sourceMappingURL=dotnet.js.map